import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=6dde083a&scoped=true"
import script from "./ImageMessage.vue?vue&type=script&lang=js"
export * from "./ImageMessage.vue?vue&type=script&lang=js"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&id=6dde083a&prod&lang=scss&scoped=true"
import style1 from "./ImageMessage.vue?vue&type=style&index=1&id=6dde083a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde083a",
  null
  
)

export default component.exports